module.exports = __webpack_public_path__ + "static/media/Icone-DicomZip.3ded5aeb.svg";